import { type ComponentType } from 'react';

import CryptoES from 'crypto-es';

import { reloadWithCounter } from '@helpers/location';

/**
 * Handles automatic retry of chunk load on fail. Then refreshes after retry count was exhausted
 */
const componentLoader = <Type = { default: ComponentType<unknown> }>(
  /** Import of component */
  fn: () => Promise<Type>,
  /** Number of times to retry load of chunk */
  retriesLeft = 2,
  /** Number of milliseconds to wait between retries */
  interval = 1000
): Promise<Type> => {
  const chunkHash = CryptoES.SHA512(fn.toString()).toString(CryptoES.enc.Hex) || 'unknown';
  const stateKey = `reloadCount(${chunkHash})`;

  return new Promise((resolve, reject) => {
    fn()
      .then(component => {
        if (window.history.state?.[stateKey] > 0) {
          const updatedHistory = { ...window.history.state };
          delete updatedHistory[stateKey];
          window.history.replaceState(updatedHistory, '');
        }

        resolve(component);
      })
      .catch(error => {
        setTimeout(() => {
          if (retriesLeft === 0) {
            if (reloadWithCounter(stateKey, 1)) {
              reject();
              return;
            }

            // TODO: Add error message for user
            reject(error);
            return;
          }

          componentLoader(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};

export default componentLoader;
